  export const players20242025 = [
    // Goalies
    {
      name: "Adam Tanouti",
      team: "PEDRI FC",
      position: "GK",
      goals: 0,
      assists: 1,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
      GA: 13,
    },
    {
      name: "Aref El-Tawil",
      team: "COLE WORLD FC",
      position: "GK",
      goals: 0,
      assists: 1,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
      GA: 12,
    },
    {
      name: "Muneer Nazir",
      team: "DEMBELE FC",
      position: "GK",
      goals: 0,
      assists: 0,
      yellowCards: 1,
      redCards: 0,
      cleanSheets: 0,
      GA: 15,
    },

    {
      name: "Khaled Al-Kadri",
      team: "VALVERDE FC",
      position: "GK",
      goals: 0,
      assists: 0,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
      GA: 21,
    },
    {
      name: "Adam Zahwee",
      team: "BOMBS FC",
      position: "GK",
      goals: 0,
      assists: 1,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
      GA: 41,
    },
    {
      name: "Adam Deeb",
      team: "BOMBS FC",
      position: "FWD",
      goals: 1,
      assists: 0,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Shaheryar Ahsan",
      team: "DABEAST FC",
      position: "GK",
      goals: 0,
      assists: 0,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
      GA: 22,
    },

    // Defenders
    {
      name: "Mosaab Jomha",
      team: "DABEAST FC",
      position: "DEF",
      goals: 0,
      assists: 1,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Bilal Rahal",
      team: "PEDRI FC",
      position: "DEF",
      goals: 0,
      assists: 0,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Rasheed Jomha",
      team: "PEDRI FC",
      position: "DEF",
      goals: 2,
      assists: 2,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Mohamed Al-Turk",
      team: "BOMBS FC",
      position: "DEF",
      goals: 1,
      assists: 0,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Mohammed Elkhatib",
      team: "DABEAST FC",
      position: "DEF",
      goals: 0,
      assists: 0,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },

    {
      name: "Mohammed Sadek",
      team: "PEDRI FC",
      position: "DEF",
      goals: 2,
      assists: 0,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },

    // Attackers
    {
      name: "Sohaib Jomha",
      team: "DEMBELE FC",
      position: "FWD",
      goals: 4,
      assists: 4,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Hussein Al-Turk",
      team: "COLE WORLD FC",
      position: "FWD",
      goals: 8,
      assists: 1,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Adnan El-Tayan",
      team: "COLE WORLD FC",
      position: "FWD",
      goals: 3,
      assists: 2,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Adnan Shaban",
      team: "DEMBELE FC",
      position: "FWD",
      goals: 4,
      assists: 2,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Rayyan Islam",
      team: "COLE WORLD FC",
      position: "FWD",
      goals: 6,
      assists: 5,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Mohamed Elmestiri",
      team: "PEDRI FC",
      position: "FWD",
      goals: 0,
      assists: 2,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Mohamed Anshasi",
      team: "COLE WORLD FC",
      position: "FWD",
      goals: 5,
      assists: 9,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Khalid Shaheen",
      team: "VALVERDE FC",
      position: "FWD",
      goals: 8,
      assists: 5,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Redouane Zerqalah",
      team: "PEDRI FC",
      position: "FWD",
      goals: 1,
      assists: 1,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Anes Mohammed",
      team: "BOMBS FC",
      position: "FWD",
      goals: 3,
      assists: 1,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Abdirahman Sheikhdon",
      team: "DEMBELE FC",
      position: "FWD",
      goals: 0,
      assists: 3,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Abdelrahman Ebeid",
      team: "VALVERDE FC",
      position: "FWD",
      goals: 3,
      assists: 3,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Mohammed Sheikh Ali",
      team: "VALVERDE FC",
      position: "FWD",
      goals: 13,
      assists: 3,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Jamal Assaf",
      team: "BOMBS FC",
      position: "FWD",
      goals: 2,
      assists: 2,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },

    // Both
    {
      name: "Adnan El-Tawil",
      team: "VALVERDE FC",
      position: "BOTH",
      goals: 2,
      assists: 7,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Zayd Elzein",
      team: "DABEAST FC",
      position: "BOTH",
      goals: 5,
      assists: 4,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Omar Jomha",
      team: "DEMBELE FC",
      position: "BOTH",
      goals: 0,
      assists: 0,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Yazan Al Maani",
      team: "VALVERDE FC",
      position: "BOTH",
      goals: 1,
      assists: 0,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Motassim Assaf",
      team: "BOMBS FC",
      position: "BOTH",
      goals: 0,
      assists: 0,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Zakariya Assaf",
      team: "DABEAST FC",
      position: "BOTH",
      goals: 1,
      assists: 4,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Omar Assaf",
      team: "DABEAST FC",
      position: "BOTH",
      goals: 1,
      assists: 0,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Ahmed Assaf",
      team: "VALVERDE FC",
      position: "BOTH",
      goals: 7,
      assists: 9,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Yaqin Issa",
      team: "DABEAST FC",
      position: "BOTH",
      goals: 9,
      assists: 2,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Sami El-Sayed",
      team: "DABEAST FC",
      position: "BOTH",
      goals: 0,
      assists: 1,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Rehan Khadri",
      team: "COLE WORLD FC",
      position: "BOTH",
      goals: 1,
      assists: 1,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Taha El-Sayed",
      team: "VALVERDE FC",
      position: "BOTH",
      goals: 0,
      assists: 2,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Rahal Rahal",
      team: "DEMBELE FC",
      position: "BOTH",
      goals: 7,
      assists: 2,
      yellowCards: 1,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Huthayfah Jomha",
      team: "PEDRI FC",
      position: "BOTH",
      goals: 5,
      assists: 3,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Yousif Al Mishhedani",
      team: "DEMBELE FC",
      position: "BOTH",
      goals: 2,
      assists: 1,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Amir Bensekhria",
      team: "BOMBS FC",
      position: "BOTH",
      goals: 4,
      assists: 1,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Mostafa Heider",
      team: "BOMBS FC",
      position: "BOTH",
      goals: 0,
      assists: 1,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Sohaib Khadri",
      team: "COLE WORLD FC",
      position: "BOTH",
      goals: 3,
      assists: 1,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
    {
      name: "Abdullah Aderinto",
      team: "PEDRI FC",
      position: "BOTH",
      goals: 6,
      assists: 5,
      yellowCards: 0,
      redCards: 0,
      cleanSheets: 0,
    },
  ];